var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRobotFoundError = function SvgRobotFoundError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 230,
    height: 201,
    viewBox: "0 0 230 201"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-3 -21)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.8,
    cy: 213.5,
    fill: "#534B6E",
    rx: 71.5,
    ry: 8.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m161.163 173.149-4.526 28.574-57.207-9.061 4.526-28.574 57.207 9.06zm-47.535 9.209-6.129-.971-.97 6.123 6.13.97.97-6.122zm38.82 6.148-6.13-.97-.97 6.122 6.13.971zm-37.203-16.353-6.13-.971-.97 6.123 6.13.97zm38.819 6.148-6.13-.97-.97 6.122 6.13.971z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.066,
    height: 17.048,
    x: 9.428,
    y: 105.025,
    fill: "#FFF",
    rx: 8.524
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.066,
    height: 17.048,
    x: 170.47,
    y: 168.934,
    fill: "#FFF",
    rx: 8.524
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.136 66.1 5.995 1.606-6.418 23.952-5.995-1.607z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.03 72.489 20.83 5.58-3.21 11.977-20.83-5.58zM201.9 109.43l25.975 6.96-3.209 11.976-25.976-6.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.982 109.466 5.995 1.606-6.418 23.952-5.995-1.606zm2.564-33.543-27.811 103.793-9.49-2.543c-.023-5.268-3.547-10.081-8.881-11.51-5.34-1.431-10.797.975-13.45 5.526L56.87 141.168 84.68 37.375zm-99.437 55.437c-2.197 7.882 1.031 13.835 6.31 15.249s11.609-2.2 13.67-9.895l-.212-.057c-2.784-.756-18.95-5.256-19.768-5.297M112.647 57.56l-.01-.003C101.136 54.474 89.314 61.3 86.232 72.8c-3.082 11.502 3.744 23.324 15.245 26.406l.01.003c11.501 3.081 23.323-3.744 26.405-15.246 3.082-11.5-3.744-23.323-15.245-26.405zm72.337 36.107-.017-.004a8.525 8.525 0 0 0-10.461 10.364l14.355 3.847a8.524 8.524 0 0 0-3.877-14.207"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m71.862 37.789 19.672 5.269-13.643 50.905-19.672-5.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m85.888 41.809 4.553-14.89 57.284 17.51-4.553 14.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F70C54",
    d: "M158.052 88.025c-7.535 28.12-36.175 44.879-63.97 37.431a51.45 51.45 0 0 1-26.271-16.782 12.56 12.56 0 0 1-10.654 1.98 13 13 0 0 1-2.24-.833l-5.797 3.168a4 4 0 0 1-2.025 3.025l-33.864 18.892a4 4 0 0 1-5.442-1.544l-.01-.02-4.512-8.192a4 4 0 0 1 1.555-5.423l33.864-18.892a4 4 0 0 1 4.844.731l4.314-2.53c-.053-1.246.08-2.52.42-3.788a12.58 12.58 0 0 1 8.59-8.812c-1.823-8.104-1.76-16.776.545-25.381 7.535-28.12 36.175-44.88 63.97-37.432 27.794 7.448 44.218 36.281 36.683 64.402m-12.747-2.656c5.737-21.41-6.706-43.347-27.791-48.996s-42.83 7.126-48.566 28.536c-2.479 9.25-1.564 18.597 1.974 26.687.595.902 1.071 1.88 1.417 2.908 4.969 9.258 13.538 16.49 24.4 19.4 21.085 5.65 42.83-7.125 48.566-28.535"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.823,
    height: 6.199,
    x: 117.885,
    y: 204.603,
    fill: "#FFF",
    rx: 3.1
  })))));
};
export default SvgRobotFoundError;